import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const isSaving = (state: RootState) => state.pages.editor.scene.saving;

const isSceneSaving = createSelector([isSaving], (saving) => saving);

export default isSceneSaving;
